module.exports = __webpack_public_path__ + "static/about-2071b1987436cfe557e5d7414b04df1c.png";